import type { OnInit } from '@angular/core';
import { Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { MatLegacyFormFieldAppearance as MatFormFieldAppearance } from '@angular/material/legacy-form-field';

@Component({
    selector: 'app-input-static',
    styleUrls: ['./static-input.component.scss'],
    template: `
        <mat-form-field [appearance]="appearance">
            <mat-label *ngIf="label">
                {{ label }}
            </mat-label>

            <div matPrefix>
                <ng-content select="[appPrefix]"></ng-content>
            </div>

            <input type="text" matInput [value]="value" [readonly]="true"/>

            <div matSuffix>
                <ng-content select="[appSuffix]"></ng-content>
            </div>

            <mat-hint *ngIf="hint">
                {{ hint }}
            </mat-hint>
        </mat-form-field>
    `,
})
export class StaticInputComponent implements OnInit {
    @Input() appearance: MatFormFieldAppearance = 'outline';
    @Input() label: string;
    @Input() value: string;
    @Input() hint: string;

    constructor(protected element: ElementRef, protected renderer: Renderer2) {
    }

    ngOnInit(): void {
        this.renderer.addClass(this.element.nativeElement, 'app-form-field');
    }

}
